import logo from "./logo.svg";
import "./App.css";
import { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import * as React from "react";
import Navbar from "./components/Navbar";
import Aboutus from "./components/Aboutus";
import Textform from "./components/Textform";
import Alert from "./components/Alert";
// import Textform from './components/About';

// const raun = 'Josh Perez';

{
  /* const element = <h1>Hello, {raun}</h1>; */
}
function App() {
  const [Mode, setMode] = useState({
    color: "rgb(5 28 52)",
    backgroundColor: "white",
  });
  const [text, setText] = useState("Light");

  const [Alrt, setAlrt] = useState(null);
 const showAlrt=(message, type)=>{
   setAlrt({
    msg: message,
    type: type
   });
 };
  const toggleMode = () => {
    // const box = document.querySelector('#boxs');
    // box.classList.add("show");
    // (document).ready(function() {
    //   ("#success-alert").hide();
    //   ("#flexSwitchCheckDefault").click(function showAlert() {
    //     ("#success-alert").fadeTo(2000, 500).slideUp(500, function() {
    //       ("#success-alert").slideUp(500);
    //     });
    //   });
    // });
    console.log("toggle clicked");
    if (Mode.color === "rgb(5 28 52)") {
      setMode({
        color: "white",
        backgroundColor: "rgb(5 28 52)",
      });
      showAlrt(" Dark Mode Enabled","success");
      
      document.body.style.backgroundColor = "rgb(5 28 52)";
      setText("Dark");
    } else {
      setMode({
        color: "rgb(5 28 52)",
        backgroundColor: "white",
      });
      showAlrt(" Light Mode Enabled","success")
      document.body.style.backgroundColor = "white";
      setText("Light");
     
    }
    setTimeout(()=> {
      setAlrt(null);
    },2500);
  };
  

  return (
    <Router>
      <Navbar title="Text" toggleMode={toggleMode} Mode={Mode} />
      <Alert Alrt={Alrt} Mode={Mode} />
     
      <div className="container my-4 box1">
        {/* <Textform heading="Enter the Text to analyze" Mode={Mode}/> */}

        <Routes>
          {/* <Textform heading="Enter the Text to analyze" Mode={Mode}/> */}
          {/* <Aboutus /> */}

          <Route
            exact
            path="/"
            element={
              <Textform heading="Enter the Text to analyze" Mode={Mode} />
            }
          />
          <Route
            exact
            path="/Text_util"
            element={
              <Textform heading="Enter the Text to analyze" Mode={Mode} />
            }
          />
          <Route exact path="/aboutus" element={<Aboutus />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
